export enum ApiKeyType {
  SDK = "sdk",
  API = "public",
}

/** Outcome of creating a key: "plan_limited" means the workspace's plan does not allow REST API keys. */
export type AddApiKeyResult = "created" | "plan_limited" | "failed";

export interface ApiKey {
  id: string;
  created: string;
  key: string;
  type: ApiKeyType;
}

export const getTypeAsText = (type: ApiKeyType) => {
  switch (type) {
    case ApiKeyType.API:
      return "REST API key";
    default:
      return "App API key";
  }
};
